var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 13C3 13.3333 3.26667 13.6666 3.66667 13.6666H6.33334C6.73334 13.6666 7 13.3333 7 13V12.3333H3V13ZM5 0.333313C2.4 0.333313 0.333336 2.39998 0.333336 4.99998C0.333336 6.59998 1.13334 7.99998 2.33334 8.79998V10.3333C2.33334 10.6666 2.6 11 3 11H7C7.4 11 7.66667 10.6666 7.66667 10.3333V8.79998C8.86667 7.93331 9.66667 6.53331 9.66667 4.99998C9.66667 2.39998 7.6 0.333313 5 0.333313Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13C3 13.3333 3.26667 13.6666 3.66667 13.6666H6.33334C6.73334 13.6666 7 13.3333 7 13V12.3333H3V13ZM5 0.333313C2.4 0.333313 0.333336 2.39998 0.333336 4.99998C0.333336 6.59998 1.13334 7.99998 2.33334 8.79998V10.3333C2.33334 10.6666 2.6 11 3 11H7C7.4 11 7.66667 10.6666 7.66667 10.3333V8.79998C8.86667 7.93331 9.66667 6.53331 9.66667 4.99998C9.66667 2.39998 7.6 0.333313 5 0.333313Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/LightBulb.aa71e6c511fc58d44c2db4155e19eaad.svg";
export { ForwardRef as ReactComponent };